export const stringToAnchorId = (str?: string) => {
  if (!str) return undefined;

  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // replace non-alphanumerics to hyphens
    .replace(/[\-]+/g, '-') // reduce duplicate hyphens to one
    .replace(/^[\-]+|[\-]+$/g, ''); // trim first and lash slashes
};
